/**
 * 时间快捷配置
 */
export const shortcutsDateOptions = {
    shortcuts: [
        {
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 3);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '最近六个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 6);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '今年至今',
            onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getFullYear(), 0);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '今年整年',
            onClick(picker) {
                const end = new Date(new Date().getFullYear(), 11, 31);
                const start = new Date(new Date().getFullYear(), 0, 1);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '未来六个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                end.setMonth(start.getMonth() + 6);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '未来一年',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                end.setMonth(start.getMonth() + 12);
                picker.$emit('pick', [start, end]);
            }
        },
    ]
};

/**
 * 分页默认配置
 * @type {{layout: string, total: number, is_show: boolean, page_size: number}}
 */
export const pagingData = {
    is_show: true,
    layout: 'total, sizes, prev, pager, next, jumper',
    total: 0,
    page_size: 20,
}

/**
 * 联系电话正则
 * @type {RegExp}
 */
// eslint-disable-next-line
export const telephoneRule = /(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3578]\d{9})$)|(^(400)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(400)-(\d{3})-(\d{4}$))/;